import { api } from 'api'
import { format } from 'date-fns'

export type WorkerEvaluationReviewStatus = 'pending_review' | 'reviewed' | 'all'

export type GetWorkerEvaluationsParams = {
  reviewStatus?: WorkerEvaluationReviewStatus
  startDate?: Date
  endDate?: Date
  locationId?: number
  positionId?: number
  workerId?: number
  cursor?: string
}

export type WorkerEvaluationShift = {
  id: number
  startsAt: string
  endsAt: string
  lunchLength?: number | null
  isTryout: boolean
  location: {
    id: number
    name: string
    timezone?: string | null
  }
  position: {
    id: number
    name: string
    roster?: {
      id: number
      name: string
    } | null
  }
}

export type WorkerEvaluationDateGroup = {
  date: string
  shifts: WorkerEvaluationShift[]
}

export type GetWorkerEvaluationsResponse = {
  groups: WorkerEvaluationDateGroup[]
  nextCursor?: string | null
}

export async function getWorkReview(
  companyId: number,
  params: GetWorkerEvaluationsParams,
  signal?: AbortSignal
) {
  const response = await api.get<GetWorkerEvaluationsResponse>(
    `/company/${companyId}/work_review`,
    {
      params: {
        reviewStatus: params.reviewStatus,
        startDate: params.startDate
          ? format(params.startDate, 'yyyy-MM-dd')
          : undefined,
        endDate: params.endDate
          ? format(params.endDate, 'yyyy-MM-dd')
          : undefined,
        locationId: params.locationId,
        positionId: params.positionId,
        workerId: params.workerId,
        cursor: params.cursor,
      },
      signal,
    }
  )

  return response.data
}
